import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { useAuth } from '../context/AuthContext';

/**
 * Hook to get the current user's influencer profile with real-time updates
 * This is the single source of truth for the influencer profile data
 * Used by Sidebar, Navbar, and other components that need the current user's profile
 */
export function useCurrentInfluencerProfile() {
  const { user, profile: authProfile } = useAuth();
  const [influencerProfile, setInfluencerProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Only load if user is authenticated and is an influencer
    if (!user || !authProfile || authProfile.userType !== 'influencer') {
      setInfluencerProfile(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    const influencerRef = doc(db, 'influencers', user.uid);

    // Subscribe to real-time updates
    const unsubscribe = onSnapshot(
      influencerRef,
      (snap) => {
        if (snap.exists()) {
          const data = snap.data();
          setInfluencerProfile({
            id: snap.id,
            userId: snap.id,
            ...data,
          });
        } else {
          setInfluencerProfile(null);
        }
        setLoading(false);
      },
      (error) => {
        console.error('Error loading influencer profile:', error);
        setInfluencerProfile(null);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [user, authProfile]);

  return { influencerProfile, loading };
}

